/**************************************************
 * Nombre:       Home_Perspectiva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import foto from '../../../Recursos/foto_perspectiva.png'
import estudiantes from '../../../Recursos/estudiantes.svg'
import {FiberManualRecord} from '@mui/icons-material'


const Home_Perspectiva = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
                spacing={6}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      alignItems={'flex-start'}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 5}}
                        spacing={0}
                        sx={{mt: 4}}
                    >
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, color: theme.palette.primary.main, fontWeight: 600}}>
                                Perspectiva General
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 40, fontFamily: NEGRITA, lineHeight: 1.1, fontWeight: 400}}>
                                Descubre lo que define nuestra excelencia académica
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 16}}>
                                Transformamos tu talento en competencias reales con enfoque en tecnología y
                                emprendimiento
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                            sx={{mt: 2}}
                        >


                            {items.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 0}}>
                                        <Typography sx={{fontWeight: 600}}>
                                            <FiberManualRecord sx={{fill: theme.palette.primary.main,mt: 0.7, mb: -0.7, pr: 0.5}}/>

                                            {it}</Typography>
                                    </Grid>
                                )
                            })}

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <img src={estudiantes} width={170} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Button sx={{color: '#fff'}}>Mas Informacion</Button>
                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 7}}>


                        <img src={foto} width={'100%'} height={'auto'}/>


                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Perspectiva

const items = [
    'Innovación Pedagógica', 'Visión Universitaria', 'Calidad Certificada'
]
